import { render, staticRenderFns } from "./StoreSafetyEdu.vue?vue&type=template&id=3298b3c2&scoped=true&"
import script from "./StoreSafetyEdu.vue?vue&type=script&lang=js&"
export * from "./StoreSafetyEdu.vue?vue&type=script&lang=js&"
import style0 from "./StoreSafetyEdu.vue?vue&type=style&index=0&id=3298b3c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3298b3c2",
  null
  
)

export default component.exports